/* ==========================================================================
   Bold Movement — bm-pdp.js v2.1 [CDN-BUST 1781316045]
   Killer product page behavior. Ship as: theme/assets/bm-pdp.js
   Reads colorway data from <script type="application/json" id="bm-pdp-data">.
   Works identically in the HTML preview and inside the Liquid section:
   data.context = "preview" | "shopify".
   ========================================================================== */

(function () {
  'use strict';

  var root = document.querySelector('.bm-pdp');
  if (!root) return;

  var dataEl = document.getElementById('bm-pdp-data');
  if (!dataEl) return;
  var data = JSON.parse(dataEl.textContent);
  var colorways = data.colorways || [];
  var isShopify = data.context === 'shopify';

  /* ---- helpers ---- */

  function $(sel, scope) { return (scope || root).querySelector(sel); }
  function $all(sel, scope) { return Array.prototype.slice.call((scope || root).querySelectorAll(sel)); }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  /* ---- gallery: thumb click swaps main image ---- */

  var mainImg = $('[data-pdp-main-img]');
  var mainPh = $('[data-pdp-main-ph]');

  function setMainImage(src, alt, phLabel) {
    if (src && mainImg) {
      // Clear srcset/sizes — otherwise the browser keeps picking from the
      // original featured image's srcset and ignores our new src.
      mainImg.removeAttribute('srcset');
      mainImg.removeAttribute('sizes');
      mainImg.src = src;
      mainImg.alt = alt || '';
      mainImg.hidden = false;
      if (mainPh) mainPh.hidden = true;
    } else {
      if (mainImg) mainImg.hidden = true;
      if (mainPh) {
        mainPh.hidden = false;
        var span = mainPh.querySelector('span');
        if (span && phLabel) span.textContent = phLabel;
      }
    }
  }

  /* ---- Aggressive image lock: defeats any other handler that tries to
     overwrite the main image src after a colorway swatch click. Locks for
     1.5 seconds (or until released by a thumbnail click). ---- */
  var imageLockObs = null;
  var imageLockTimer = null;
  var imageLockedSrc = null;

  function lockMainImage(targetSrc, targetAlt) {
    releaseMainImageLock();
    if (!mainImg) return;
    imageLockedSrc = targetSrc;
    setMainImage(targetSrc, targetAlt);
    // Watch for any unwanted src change and revert
    imageLockObs = new MutationObserver(function () {
      if (!mainImg || !imageLockedSrc) return;
      var current = mainImg.src || '';
      var currentKey = current.split('?')[0].split('#')[0];
      var targetKey = imageLockedSrc.split('?')[0].split('#')[0];
      if (currentKey !== targetKey) {
        // Disconnect briefly so our own write doesn't re-fire us
        imageLockObs.disconnect();
        mainImg.src = imageLockedSrc;
        mainImg.alt = targetAlt || '';
        if (imageLockedSrc) {
          imageLockObs.observe(mainImg, { attributes: true, attributeFilter: ['src'] });
        }
      }
    });
    imageLockObs.observe(mainImg, { attributes: true, attributeFilter: ['src'] });
    // Auto-release after 1.5s so thumb clicks work normally afterward
    imageLockTimer = setTimeout(releaseMainImageLock, 1500);
  }

  function releaseMainImageLock() {
    if (imageLockObs) {
      imageLockObs.disconnect();
      imageLockObs = null;
    }
    if (imageLockTimer) {
      clearTimeout(imageLockTimer);
      imageLockTimer = null;
    }
    imageLockedSrc = null;
  }

  function bindThumbs() {
    $all('[data-pdp-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        releaseMainImageLock();
        $all('[data-pdp-thumb]').forEach(function (b) { b.setAttribute('aria-current', 'false'); });
        btn.setAttribute('aria-current', 'true');
        var img = btn.querySelector('img');
        if (img) {
          setMainImage(img.src, img.alt);
        } else {
          var span = btn.querySelector('span');
          setMainImage(null, '', span ? span.textContent : '');
        }
      });
    });
  }
  bindThumbs();

  /* ---- colorway switching ---- */

  var current = colorways.findIndex(function (c) { return c.current; });
  // IMPORTANT: if current < 0, this product is NOT one of the 3 colorways
  // (e.g., it's a bundle product like the 2/4/6/10-pack). We must NOT default
  // to colorway 0 (Aegean) and overwrite the server-rendered title/price/etc.
  // Just leave the page alone — Shopify already rendered it correctly.
  var isColorwayProduct = current >= 0;

  function renderColorway(i, pushUrl) {
    var c = colorways[i];
    if (!c) return;
    current = i;

    root.style.setProperty('--pdp-stage', c.stage);
    root.style.setProperty('--pdp-accent', c.accent);

    var eyebrow = $('[data-pdp-eyebrow]');
    if (eyebrow) eyebrow.textContent = c.eyebrow;

    var title = $('[data-pdp-title]');
    if (title) title.textContent = c.title;

    var crumb = $('[data-pdp-crumb]');
    if (crumb) crumb.textContent = c.title;

    var flag = $('[data-pdp-flag]');
    if (flag) {
      flag.textContent = c.flag || '';
      flag.hidden = !c.flag;
    }

    var swatchName = $('[data-pdp-swatch-name]');
    if (swatchName) swatchName.textContent = c.colorName;

    $all('[data-pdp-swatch]').forEach(function (btn, j) {
      btn.setAttribute('aria-pressed', j === i ? 'true' : 'false');
    });

    /* Note: gallery images (main + thumbs) are server-rendered with the
       correct product's media when the page loads (since swatches now use
       native anchor navigation). We DON'T touch them here — that lets the
       thumbnail click handler in bindThumbs() swap the main image freely
       without any lock fighting it. */

    /* price */
    var price = $('[data-pdp-price]');
    if (price && c.price != null) price.textContent = money(c.price);

    /* sticky bar */
    var sName = $('[data-pdp-sticky-name]');
    if (sName) sName.textContent = c.title;
    var sPrice = $('[data-pdp-sticky-price]');
    if (sPrice && c.price != null) sPrice.textContent = money(c.price);
    var sThumb = $('[data-pdp-sticky-img]');
    if (sThumb && c.images && c.images[0]) {
      sThumb.src = c.images[0].src;
      sThumb.alt = c.images[0].alt || '';
    }

    /* buy form target (Shopify variant id) */
    var idInput = $('[data-pdp-variant-id]');
    if (idInput && c.variantId) idInput.value = c.variantId;

    /* "you might also like" shows the OTHER two colorways */
    var alsoCards = $all('[data-pdp-also]');
    var others = colorways.filter(function (_, j) { return j !== i; });
    alsoCards.forEach(function (card, j) {
      var o = others[j];
      if (!o) { card.hidden = true; return; }
      card.hidden = false;
      card.href = o.url || '#';
      var img = card.querySelector('img');
      if (img && o.images && o.images[0]) { img.src = o.images[0].src; img.alt = o.images[0].alt || ''; }
      var stage = card.querySelector('[data-also-stage]');
      if (stage) stage.style.background = o.stage;
      var name = card.querySelector('[data-also-name]');
      if (name) name.textContent = o.title;
      var price = card.querySelector('[data-also-price]');
      if (price && o.price != null) price.textContent = money(o.price);
    });

    /* document title + URL */
    if (c.pageTitle) document.title = c.pageTitle;
    if (pushUrl && c.url && window.history && window.history.replaceState) {
      try { window.history.replaceState({}, '', c.url); } catch (e) { /* preview: cross-origin no-op */ }
    }
  }

  // Swatches are now native <a> anchors with href to each colorway product.
  // Browser handles navigation. No JS click handler needed — Dawn's soft-nav
  // (product-info.js + global.js) cannot intercept native anchor clicks.

  // Initial render only runs for the 3 known colorway products (Aegean/Onyx/
  // Artemis). For bundles or any other product, skip — the server already
  // rendered the page with correct title/price/etc. Calling renderColorway
  // with a wrong index would overwrite those with Aegean data.
  if (isColorwayProduct) {
    renderColorway(current, false);
  }

  /* ---- quantity stepper ---- */

  var qtyInput = $('[data-pdp-qty]');
  $all('[data-pdp-qty-minus]').forEach(function (b) {
    b.addEventListener('click', function () {
      qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
    });
  });
  $all('[data-pdp-qty-plus]').forEach(function (b) {
    b.addEventListener('click', function () {
      qtyInput.value = Math.min(99, (parseInt(qtyInput.value, 10) || 1) + 1);
    });
  });

  /* ---- add to cart ---- */

  function toast(msg) {
    var t = document.createElement('div');
    t.textContent = msg;
    t.setAttribute('role', 'status');
    t.style.cssText =
      'position:fixed;left:50%;bottom:84px;transform:translateX(-50%);z-index:99;' +
      'background:#0E0E10;color:#F4EFE7;font:500 12px/1.4 "JetBrains Mono",monospace;' +
      'letter-spacing:.12em;text-transform:uppercase;padding:12px 20px;max-width:90vw;text-align:center;';
    document.body.appendChild(t);
    setTimeout(function () { t.remove(); }, 2600);
  }

  function addToCart(variantId, qty, label) {
    if (!isShopify) {
      toast((label || 'Added') + ' — cart drawer opens on the live store');
      return;
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty || 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart');
      /* reuse theme cart drawer if present (Dawn) */
      var drawer = document.querySelector('cart-drawer');
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      if (drawer && typeof drawer.open === 'function') drawer.open();
      else window.location.href = '/cart';
    }).catch(function () {
      window.location.href = '/cart';
    });
  }

  $all('[data-pdp-atc]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      if (btn.tagName === 'BUTTON' && btn.type === 'submit' && isShopify) return; /* Dawn form handles it */
      e.preventDefault();
      // On non-colorway products (bundles), the Shopify form handles ATC
      // normally — there's no colorway variant to look up.
      if (!isColorwayProduct) return;
      var c = colorways[current];
      addToCart(c.variantId, parseInt(qtyInput && qtyInput.value, 10) || 1, 'Pre-order placed');
    });
  });

  /* bundle upsells */
  $all('[data-pdp-bundle]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      var vid = btn.getAttribute('data-variant-id');
      var url = btn.getAttribute('data-url');
      if (vid) { e.preventDefault(); addToCart(vid, 1, btn.getAttribute('data-label') || 'Bundle added'); }
      else if (url && isShopify) { window.location.href = url; }
      else { e.preventDefault(); toast('Bundle added — links to bundle product on the live store'); }
    });
  });

  /* ---- copy promo code ---- */

  $all('[data-pdp-copycode]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var code = btn.getAttribute('data-code') || 'BOLDME';
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(function () {
          var prev = btn.textContent;
          btn.textContent = 'Copied';
          setTimeout(function () { btn.textContent = prev; }, 1800);
        });
      }
    });
  });

  /* ---- sticky mobile bar: show after the buy actions scroll out of view ---- */

  var stickyBar = $('[data-pdp-stickybar]');
  var sentinel = $('[data-pdp-sticky-sentinel]');
  if (stickyBar && sentinel && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      var below = e.boundingClientRect.top < 0;
      stickyBar.setAttribute('data-visible', (!e.isIntersecting && below) ? 'true' : 'false');
    }, { threshold: 0 });
    io.observe(sentinel);
  }
})();

// v2 fresh deploy 1781316364
